import React, { useState } from 'react'
import { Link } from 'react-router-dom';
import FsLightbox from 'fslightbox-react';
import { Element } from 'react-scroll';
import { FaPlay } from 'react-icons/fa';
import { scrollToViewFromTop } from '../../utils/scrollToViewFromTop';

const AMBanner = () => {
  const [toggler, setToggler] = useState(false);
  const videoLink = ['https://www.youtube.com/embed/rxKfq5j0gHg?autoplay=1&rel=0'];

  return (
    <Element
      name="datatalent-banner"
      className="data-talent-jobseekers-banner am-banner banner-style-1 bg-image height-640 d-flex align-items-center"
    >
      <div className="container eduvibe-animated-shape">
        <div className="row g-5 align-items-center">
          <div className="order-1 order-xl-1 col-lg-12 col-xl-6 banner-left-content">
            <div className="inner">
              <div className="content position-relative">
                <div className="datatalent-jobseekers-breadcrumb d-flex align-items-center">
                  <Link to="/programs">Our Programs</Link>
                  <i className="ri-arrow-drop-right-line"></i>
                  Annual Membership Programs
                </div>
                <h1 className="datatalent-program-title title mt-4">Annual Membership Programs</h1>
                <p className="description">Through our comprehensive <strong>12-month membership</strong> program, which includes self-paced courses, work-integrated learning projects, and personalized mentorship, we aim to equip you with the skills and connections needed to excel in the ever-evolving tech landscape.<br></br>
                <br></br>Whether you are just starting out or looking to enhance your expertise, our <strong>diverse range</strong> of annual membership options is designed to support your growth and help you achieve your career goals.</p>
                {/* <span className="datatalent-description-span">*eligibility requirements below</span> */}
                <div className="read-more-btn banner-btns">
                  {/* <button className="edu-btn" onClick={() => setShowEmployerRegisterForm(true)}>Employer Login</button>
                  <button className="edu-btn btn-secondary" onClick={() => setShowUserInterestForm(true)}>Jobseekers Login</button> */}
                  <div className="col-6 col-lg-4">
                    <button className="edu-btn btn-primary text-center" onClick={() => scrollToViewFromTop("MembershipPackages")}>Select Membership</button>
                  </div>
                  <div className="col-6 col-lg-4 d-flex justify-content-end">
                    <Link className="edu-btn btn-bg-alt text-center" to="/contact-us">Contact Us</Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="order-2 order-xl-3 col-lg-12 col-xl-6 d-flex flex-column align-items-center justify-content-center banner-right-content">
            <div className="feature-thumbnail">
              <div className="main-image video-popup-wrapper video-popup-two">
                <img src={`${process.env.PUBLIC_URL}/images/videopopup/pexels-monstera-6238170_v2.png`} alt="Video PopUp Thumb" loading="lazy" />

                <button className="video-play-btn with-animation position-to-top btn-large video-popup-activation eduvibe-video-play-icon color-secondary" onClick={ () => setToggler( ! toggler ) }><span><FaPlay className="play-icon" /></span></button>
              </div>
            </div>
            <div className="datatalent-stats-container d-flex align-items-start justify-content-center">
              <div className="col-4 datatalent-stats-courses">
                <h5 className="datatalent-stat-header">14,000+ Course Enrollments</h5>
                {/* <h5 className="datatalent-stat-header d-block d-md-none">80+<br></br>courses</h5> */}
                <p className="datatalent-stat-description d-none d-md-block">Join thousands of learners advancing their careers with M2M Tech</p>
              </div>
              <div className="col-4 datatalent-stats-ratings">
                <h5 className="datatalent-stat-header">1,000+ Program Graduates</h5>
                {/* <h5 className="datatalent-stat-header d-block d-md-none">12<br></br>Weeks</h5> */}
                <p className="datatalent-stat-description d-none d-md-block">Our graduates are excelling and making an impact in the industry</p>
              </div>
              <div className="col-4 datatalent-stats-schedule">
                <h5 className="datatalent-stat-header d-none d-md-block">300+ Courses Available</h5>
                <h5 className="datatalent-stat-header d-block d-md-none">300+<br></br> Courses Available</h5>
                {/* <h5 className="datatalent-stat-header d-block d-md-none">300+<br></br>Graduates</h5> */}
                <p className="datatalent-stat-description d-none d-md-block">Explore a wide range of courses tailored to today's workforce needs</p>
              </div>
            </div>
          </div>
        </div>
        <div className="video-lightbox-wrapper">
          <FsLightbox
            toggler={ toggler } 
            sources={ [ <iframe src={videoLink} style={{"width": "960px"}} height="540px" frameBorder="0" title="Youtube video player" allow="autoplay; fullscreen" /> ] }
            maxYoutubeVideoDimensions={ { width: 960, height: 540 } }
          />
        </div>
      </div>
    </Element>
  )
}

export default AMBanner;